module.exports = __webpack_public_path__ + "static/img/Roxanne.80bec26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/Roxanne.jpg
// module id = 203
// module chunks = 1